import './ccf-video-outline-icon.module.scss';
import { SvgIcon, SvgIconProps} from '@mui/material';

/* eslint-disable-next-line */
export interface CcfVideoOutlineIconProps extends SvgIconProps  {}

/**
 * CcfVideoOutlineIcon used to disply video outline icon in the contact card panel
 * @param props - CcfVideoOutlineIconProps
 * @example -- <CcfVideoOutlineIcon />
 */
export function CcfVideoOutlineIcon(props: CcfVideoOutlineIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g id="Action_Video" clipPath="url(#clip-Action_Video)">
        <path id="video" d="M21.53,7.15a1,1,0,0,0-1,0L17,8.89A3,3,0,0,0,14,6H5A3,3,0,0,0,2,9v6a3,3,0,0,0,3,3h9a3,3,0,0,0,3-2.89l3.56,1.78A.991.991,0,0,0,22,16V8A1,1,0,0,0,21.53,7.15ZM15,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8h9a1,1,0,0,1,1,1Zm5-.62-3-1.5V11.12l3-1.5Z" transform="translate(0 0)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfVideoOutlineIcon;
